"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.RolesGuard = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const core_1 = require("@nestjs/core");
let RolesGuard = class RolesGuard {
    constructor(reflector) {
        this.reflector = reflector;
    }
    canActivate(context) {
        try {
            const allowedRoles = this.reflector.get("roles", context.getHandler());
            if (!allowedRoles) {
                return true; // If no roles are specified, allow access
            }
            const request = context.switchToHttp().getRequest();
            const user = request.user;
            // Extract role from user.userDetails.role
            const userRole = user?.userDetails?.role;
            if (!userRole || !allowedRoles.includes(userRole)) {
                throw new common_1.ForbiddenException("Access denied. User doesn't have permission.");
            }
            return true;
        }
        catch (error) {
            console.error("Error in RolesGuard:", error);
            throw new common_1.ForbiddenException("Access denied. User doesn't have permission.");
        }
    }
};
exports.RolesGuard = RolesGuard;
exports.RolesGuard = RolesGuard = tslib_1.__decorate([
    (0, common_1.Injectable)(),
    tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof core_1.Reflector !== "undefined" && core_1.Reflector) === "function" ? _a : Object])
], RolesGuard);
